import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useParams } from 'react-router-dom';
import CheckoutForm from './CheckoutForm'; // Adjust the path as per your project structure
import { Container, Row, Col, Card, Form, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import MainNavbar from '../../../../Components/Navbars/MainNavbar';
import Footer from '../../../../Components/Footer';
import Sidebar from '../../../../Components/Sidebar';
import getEnvConfig from '../../../../config';

const stripePromise = loadStripe('pk_live_51OLf6SB54WNp7HCzwXLT0tFMa78NynzjdUeRm40O4b2NEY3GP3DUtQowtIJmxR7WP1z6Iq3Gc0JjmJV0qHK8mNUQ006sjqUcaX');

const ChargerDetails = () => {
  const { backendUrl } = getEnvConfig();
  const { chargerid, portId } = useParams();
  const [chargerData, setChargerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChargerData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        let url;
        // If portId is available, use the port-based endpoint
        
        url = `${backendUrl}/chargers/get_charger_by_port/${portId}`;
 
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch charger data: ${response.statusText}`);
        }
        
        const data = await response.json();
        setChargerData(data);
      } catch (err) {
        console.error('Error fetching charger data:', err);
        setError(err.message || 'Failed to load charger details');
      } finally {
        setLoading(false);
      }
    };

    fetchChargerData();
  }, [backendUrl, chargerid, portId]);

  if (loading) {
    return (
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <Container fluid style={{ marginLeft: '5px' }}>
          <Row className="justify-content-center my-5">
            <Col className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p>Loading charger details...</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <Container fluid style={{ marginLeft: '5px' }}>
          <Row className="justify-content-center my-5">
            <Col>
              <Alert variant="danger">
                {error}
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <Container fluid style={{ marginLeft: '5px' }}>
        <Row className="justify-content-center my-5">
          <Col md={8} lg={6}>
            <Elements stripe={stripePromise}>
              <CheckoutForm chargerData={chargerData} />
            </Elements>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChargerDetails;